<app-modal-window title="User transaction"
                  (close)="close()">
  <div class='transaction-content'>
    <pre>{{ data | json }}</pre>
  </div>
</app-modal-window>
